import { render, staticRenderFns } from "./Traces.vue?vue&type=template&id=6b860e96&"
import script from "./Traces.vue?vue&type=script&lang=js&"
export * from "./Traces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports